import { Library } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LibraryIcon = createLucideIcon(Library);
